import { render } from "./App.vue?vue&type=template&id=565394d6"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=565394d6&lang=css"

import exportComponent from "/Volumes/Rich Nas/Work/East Side Mafia/VUE/simple-app-2/simple-app-2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__